require('./accountPaymentPurchaseDeferral.scss');


const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

const { formatText, FormattedText } = require('core/i18n').i18n;

const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

const { getSelectedCardsForAccountPurchaseDeferral } = require('selectors/cards')

const { ConfirmationPurchaseDeferral } = require('./accountPaymentPurchaseDeferralConfirmation');
const { FinancialDataPurchaseDeferral } = require('./accountPaymentPurchaseDeferralFinancialData');
const { SelectCreditCardPurchaseDeferral } = require('./accountPaymentPurchaseDeferralSelectCreditCard');

const { clearRequest,
        setVisibleStep,
        setWillCancel,
        confirmDeferral,
        validateStep,
        clearConfirmDeferral
} = require('actions/accountPaymentPurchaseDeferral');

const { lavandaReset } = require('actions/lavanda');

const { getFormattedString } = require('utilities/currencyHelper');
const { getChosenDeferralTag, isLavandaCard } = require('utilities/lavandaHelper');
const { recordLink } = require('utilities/tagging');

const TRANSLATION_KEY_PREFIX = 'accountPaymentPurchaseDeferral';

const { DEFERRED_PAYMENT_INSUFFICIENT_BALANCE_ERROR_CODE, DEFERRED_PAYMENT_SUM, DEFERRED_PAYMENT_LIMIT_SUM } = require('constants/index');
const { LAVANDA } = require('constants/flagBasedFeatures');
const tagging = require('constants/tagging');


class AccountPaymentPurchaseDeferral extends React.PureComponent {
    constructor(props){
        super(props)

        this.state = {
            showPreLeaveModal: true
        }

        this.onFinish = this.onFinish.bind(this)
        this.renderWizard = this.renderWizard.bind(this)
        this.renderSuccesfulView = this.renderSuccesfulView.bind(this)
        this.handleWizardFinish = this.handleWizardFinish.bind(this)
    }

    componentWillReceiveProps (nextProps) {
        const { immAccountPaymentPurchaseDeferral, lavandaEnabled } = this.props;

		if (lavandaEnabled && nextProps.immAccountPaymentPurchaseDeferral.get('visibleStep') === 1 && immAccountPaymentPurchaseDeferral.get('visibleStep') === 2) {
            this.props.clearConfirmDeferral();
		}
    }

    componentDidUpdate(lastProps, lastState) {
        const { callback, showPreLeaveModal } = this.state
        if (lastState.showPreLeaveModal != showPreLeaveModal)
            callback()
    }

    componentWillUnmount(){
        this.props.clearConfirmDeferral()
        this.props.lavandaReset();
    }


    onLeaveWithoutModal = (callback) => {
        this.setState({showPreLeaveModal: false, callback})
    }

    onFinish() {
        const { confirmDeferral,
                immCard,
                immAccount,
                immMovement
            } = this.props

        confirmDeferral(immAccount.get('accountId'), immCard.get('cardId'), immMovement.get('id'))
    }

    handleWizardFinish(){
        const {
            immCard,
            immLavanda,
            lavandaEnabled,
            onConfirmLeave,
        } = this.props;

        lavandaEnabled && isLavandaCard(immCard.get('product'),immLavanda.get('cards')) && recordLink(window.utag_last_name, tagging.BACK_TO_ACCOUNTS_ACTION_EVENT);
        onConfirmLeave();
    }

    renderWizard(){
        const {
            lavandaEnabled,
            setVisibleStep,
            setWillCancel,
            validateStep,
            onConfirmLeave,
            immMovement,
            immAccount,
            immAccountPaymentPurchaseDeferral,
            immCard,
            immLavanda,
        } = this.props;

        const { showPreLeaveModal } = this.state

        const finalButtonText = TRANSLATION_KEY_PREFIX + '-finalButton';

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            cancel: onConfirmLeave,
            finish: this.onFinish
        };
        const cardProduct =  !!immCard && `${immCard.getIn(['product', 'type'])}.${immCard.getIn(['product', 'subtype'])}`;
        const accountProduct = !!immAccount && `${immAccount.get('newProduct')}.${immAccount.get('accountType')}`
        const numberQuotas = getChosenDeferralTag(immAccountPaymentPurchaseDeferral.getIn(['steps', 1, 'financingData', 'currentQuota'], null));
        const isLavandaFlow = lavandaEnabled && !!immCard && !!immLavanda && isLavandaCard(immCard.get('product'),immLavanda.get('cards'));
        const processDetail = isLavandaFlow  && numberQuotas;
        const showTagging = lavandaEnabled && (immAccountPaymentPurchaseDeferral.get('visibleStep') === 1 || isLavandaFlow);
        let tealium = {};
        let tealiumEvents = {};

        if (showTagging){
            tealium = {
                processDetail,
                productName: immAccountPaymentPurchaseDeferral.get('visibleStep') === 1 ? accountProduct : cardProduct,
            };
            tealiumEvents = { 
                cancel: {eventName: tagging.DEFERRAL_PAYMENT_CANCEL},
                finish: {eventName: tagging.DEFERRAL_PAYMENT_FINISH, eventTag: processDetail},
                next: {eventName: tagging.DEFERRAL_PAYMENT_NEXT, eventTag: immAccountPaymentPurchaseDeferral.get('visibleStep') === 1 ? cardProduct : processDetail},
                previous: isLavandaFlow && {eventName: tagging.DEFERRAL_PAYMENT_PREVIOUS},
            };
        }

        return (
            <Wizard
                actions={actions}
                immSteps={immAccountPaymentPurchaseDeferral.get('steps')}
                visibleStep={immAccountPaymentPurchaseDeferral.get('visibleStep')}
                stepsAmount={3}
                wizardClass="accounts-payment-purchase-deferral__wizard"
                showPreLeaveModal={showPreLeaveModal}
                tealium={tealium}
                tealiumEvents={tealiumEvents}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                    nextButtonDisabled={immAccountPaymentPurchaseDeferral.getIn(['steps', 0, 'selectedCard'], null) === null || immAccountPaymentPurchaseDeferral.getIn(['steps', 0, 'cards'], null) === null}
                >
                    <SelectCreditCardPurchaseDeferral
                        immMovement={immMovement}
                        immAccount={immAccount}
                        immCard={immCard}
                        immAccountPaymentPurchaseDeferral={immAccountPaymentPurchaseDeferral}
                        disablePreLeaveModal={this.onLeaveWithoutModal}
                    />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton={true}
                    nextButton={true}
                    previousButton={true}
                    nextButtonDisabled={immAccountPaymentPurchaseDeferral.getIn(['steps', 1, 'financingData', 'currentQuota'], null) === null}
                >
                    <FinancialDataPurchaseDeferral
                        immMovement={immMovement}
                        immAccount={immAccount}
                        immCard={immCard}
                        immAccountPaymentPurchaseDeferral={immAccountPaymentPurchaseDeferral}
                    />
                </WizardStep>
                <WizardStep
                    addLoadingBehaviour={true}
                    cancelButton={true}
                    finishButton={true}
                    immFinalButton={finalButtonText}
                    position="last"
                    previousButton={true}
                    isLoading={false}

                >
                    <ConfirmationPurchaseDeferral
                        immMovement={immMovement}
                        immCard={immCard}
                        immAccountPaymentPurchaseDeferral={immAccountPaymentPurchaseDeferral}
                        immAccount={immAccount}
                    />
                </WizardStep>
            </Wizard>
        )
    }

    renderSuccesfulView(processDetail, product) {
        const { immMovement, immAccountPaymentPurchaseDeferral } = this.props
        const balance = {amount: Math.abs(immMovement.getIn(['balance', 'amount'])), currency: immMovement.getIn(['balance', 'currency'])}
        const amount = getFormattedString(balance)
        const quota = immAccountPaymentPurchaseDeferral.getIn(['steps', 1, 'financingData', 'currentQuota'])
        const quotaMonthly = getFormattedString(immAccountPaymentPurchaseDeferral.getIn(['steps', 1, 'financingData', 'quotaMonthly']))
        const successMessage = formatText(`${TRANSLATION_KEY_PREFIX}Success-title`, [amount, quota]);
        const mainButton = {
            label: (<FormattedText value={`${TRANSLATION_KEY_PREFIX}Success-button`}/>)
        };

        return (
            <div className="confirm-success-step col-xs-offset-2 col-xs-8">
                <WizardSuccess
                    successMessage={successMessage}
                    mainButton={mainButton}
                    onMainButtonClick={this.handleWizardFinish}
                    processDetail={processDetail}
                    productName={product}
                >
                    <FormattedText
                        injectedStrings={[amount, quota, quotaMonthly]}
                        value={`${TRANSLATION_KEY_PREFIX}Success-text`}
                    />
                </WizardSuccess>
            </div>
        );
    }


    render() {
        const {
            immAccountPaymentPurchaseDeferral,
            immCard,
            immLavanda,
            lavandaEnabled,
        } = this.props;
        const isFetching = immAccountPaymentPurchaseDeferral.get('isFetching') || lavandaEnabled && immLavanda.get('isFetching');
        const submitSuccessful = immAccountPaymentPurchaseDeferral.get('submitSuccessful')
        const error = immAccountPaymentPurchaseDeferral.get('error') || lavandaEnabled && immLavanda.get('error');
        const errorTitle = formatText(`${TRANSLATION_KEY_PREFIX}Error-title`);
        const mainButton = {
            label: (<FormattedText value={`${TRANSLATION_KEY_PREFIX}Error-button`}/>)
        };
        let errorMessage = '';
        let tagErrorMessage = '';
        let categoryError = '';
        let numberQuotas;
        let processDetail;
        let product;

        switch(error) {
            case DEFERRED_PAYMENT_LIMIT_SUM:
            case DEFERRED_PAYMENT_INSUFFICIENT_BALANCE_ERROR_CODE:
            case DEFERRED_PAYMENT_SUM:
                errorMessage = <FormattedText value={`${TRANSLATION_KEY_PREFIX}Error-${error}`} />;
                break;
            default:
                errorMessage = <FormattedText value={`${TRANSLATION_KEY_PREFIX}Error-text`}/>;
        }

        if (lavandaEnabled){
            const errorDescription = immAccountPaymentPurchaseDeferral.getIn(['error', 'description']) || immLavanda.getIn(['error', 'description']);
            numberQuotas = getChosenDeferralTag(immAccountPaymentPurchaseDeferral.getIn(['steps', 1, 'financingData', 'currentQuota'], null));
            processDetail = !!immCard && !!immLavanda && isLavandaCard(immCard.get('product'),immLavanda.get('cards')) && numberQuotas || null;
            product = !!immCard && `${immCard.getIn(['product', 'type'])}.${immCard.getIn(['product', 'subtype'])}` || null;

            switch(errorDescription) {
                case DEFERRED_PAYMENT_LIMIT_SUM:
                case DEFERRED_PAYMENT_SUM:
                    categoryError = tagging.SERVICE_DENIED;
                    tagErrorMessage = tagging.DEFERRED_PAYMENT_LIMIT;
                    break;
                case DEFERRED_PAYMENT_INSUFFICIENT_BALANCE_ERROR_CODE:
                    categoryError = tagging.SERVICE_DENIED;
                    tagErrorMessage = tagging.DEFERRED_PAYMENT_INSUFFICIENT_BALANCE;
                    break;
                default:
                    tagErrorMessage = errorDescription;
            }
        }

        if (!isFetching && submitSuccessful) {
            return this.renderSuccesfulView(processDetail, product);
        } else if (error) {
            return (
                <WizardError
                    categoryError={categoryError}
                    descriptionError={tagErrorMessage}
                    errorMessage={errorTitle}
                    mainButton={mainButton}
                    onMainButtonClick={this.handleWizardFinish}
                    processDetail={processDetail}
                    productName={product}
                >
                    <p>{errorMessage}</p>
                </WizardError>
            );
        }
        return this.renderWizard()
    }
}

AccountPaymentPurchaseDeferral.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immMovement: PropTypes.object,
    immCard: PropTypes.object,
    immAccountPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immLavanda: PropTypes.object,
    isLavandaCard: PropTypes.func,
    lavandaEnabled: PropTypes.bool,
    lavandaReset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onConfirmLeave: PropTypes.func.isRequired,
    confirmDeferral: PropTypes.func.isRequired,
    clearConfirmDeferral: PropTypes.func.isRequired

};

module.exports.constructor = AccountPaymentPurchaseDeferral;
module.exports.AccountPaymentPurchaseDeferral = connect(state => {
    return ({
        immCard: getSelectedCardsForAccountPurchaseDeferral(state),
        immLavanda: state.cards.getIn(['credit', 'lavanda']),
        lavandaEnabled: state.flagBasedFeatures.get(LAVANDA),
    })}, {
    clearRequest,
    isLavandaCard,
    lavandaReset,
    setVisibleStep,
    setWillCancel,
    confirmDeferral,
    validateStep,
    clearConfirmDeferral
})(AccountPaymentPurchaseDeferral);